import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useCodesInAdjustmentReasonCodeList from "./hooks/useCodesInAdjustmentReasonCodeList";  
  
const CodesInAdjustmentReasonCodeList = () => {  
  const codesInAdjustmentReasonCodeListData = useCodesInAdjustmentReasonCodeList();  
  
  return (  
    <div class="container container-fluid">  
        <ButtonsSection ctaButtons={codesInAdjustmentReasonCodeListData.leftButtons} align="left" />   
      <div className="header-section">  
        <h1>  
          {codesInAdjustmentReasonCodeListData.screen_title} -{" "}  
          <span className="heading-cod">{codesInAdjustmentReasonCodeListData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={codesInAdjustmentReasonCodeListData.formFields}  
        dropdownValues={codesInAdjustmentReasonCodeListData.dropdownValues}  
        paramsData={codesInAdjustmentReasonCodeListData.paramsData}  
        updataParamData={codesInAdjustmentReasonCodeListData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={codesInAdjustmentReasonCodeListData.ctaButtons} />  
      <DisplayTable  
        data={codesInAdjustmentReasonCodeListData.data}  
        parmKey={codesInAdjustmentReasonCodeListData.parmKey2}  
        menuOptions={codesInAdjustmentReasonCodeListData.menuOptions}  
        tableHeaders={codesInAdjustmentReasonCodeListData.columnDef}  
        setRowData={codesInAdjustmentReasonCodeListData.setRowData}  
        selectedPriceSchedules={codesInAdjustmentReasonCodeListData.selectedRows}  
        setSelectedPriceSchedules={codesInAdjustmentReasonCodeListData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={codesInAdjustmentReasonCodeListData.first}  
          rows={codesInAdjustmentReasonCodeListData.rows}  
          totalRecords={codesInAdjustmentReasonCodeListData.totalRecords}  
          currentPage={codesInAdjustmentReasonCodeListData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={codesInAdjustmentReasonCodeListData.onPageChange}  
        />  
      </div>  
      {codesInAdjustmentReasonCodeListData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={codesInAdjustmentReasonCodeListData.isConfirmationModalOpen}  
          onRequestClose={codesInAdjustmentReasonCodeListData.closeConfirmationModal}  
          onBack={codesInAdjustmentReasonCodeListData.closeConfirmationModal}  
          onSave={codesInAdjustmentReasonCodeListData.deleteAdjustmentReasonCode}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={codesInAdjustmentReasonCodeListData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default CodesInAdjustmentReasonCodeList;